import { createAction, props } from '@ngrx/store';
import { List, ListItem, ListType } from '@capital-access/lists/common';
import {
  CommentRequest,
  ExportDataMap,
  FilterActivityCompanyContactSuggesterItem,
  TemplateExportListItemWithComments
} from '@capital-access/reporting/common';
import {
  TemplateExportCommentsSavePayload,
  TemplateExportFilterActivityPayload
} from '../../models/template-export.model';

export const openExportListDrawer = createAction(
  scoped('Open Export List Drawer'),
  props<{ listType: ListType; allowedListLength: number }>()
);

export const loadSelectedItemsFromStorage = createAction(
  scoped('Load Selected Items From Storage'),
  props<{ selectedItems: TemplateExportListItemWithComments[] }>()
);

export const loadSelectedTimeFromStorage = createAction(
  scoped('Load Selected Time From Storage'),
  props<{ selectedTime: string }>()
);

export const getListItemsBySelectedListId = createAction(
  scoped('Load List By Selected List Id'),
  props<{ listId: number }>()
);

export const formatListForTemplateExport = createAction(
  scoped('Format List For Template Export'),
  props<{ list: List }>()
);

export const addExportItemToList = createAction(
  scoped('Add Export Item To List'),
  props<{ itemToAdd: TemplateExportListItemWithComments }>()
);

export const addRemoveItineraryToList = createAction(
  scoped('Add or Remove Itinerary To List'),
  props<{ itemsToAdd: TemplateExportListItemWithComments[] }>()
);

export const removeExportItemFromList = createAction(
  scoped('Remove Export Item From List'),
  props<{ itemToRemove: TemplateExportListItemWithComments }>()
);

export const addSecurityToList = createAction(
  scoped('Add Security To List'),
  props<{ itemToAdd: TemplateExportListItemWithComments }>()
);

export const removeSecurityFromList = createAction(
  scoped('Remove Security From List'),
  props<{ itemToRemove: TemplateExportListItemWithComments }>()
);

export const changeSelectedItem = createAction(scoped('Change Selected Item'), props<{ index: number }>());

export const changeItinerarySelectedItem = createAction(
  scoped('Change Itinerary Selected Item'),
  props<{ index: number }>()
);

export const formatListForTemplateExportSuccess = createAction(
  scoped('Format List For Template Export Success'),
  props<{ list: ListItem[] }>()
);

export const getListItemsBySelectedListIdFailure = createAction(scoped('Load List By Selected List Id Failure'));

export const openCommentSectionDrawerForSelectedItem = createAction(
  scoped('Open Comment Section Drawer For Selected Item'),
  props<{ selectedItem: TemplateExportListItemWithComments }>()
);

export const openCommentSectionDrawerForSelectedItemSuccess = createAction(
  scoped('Open Comment Section Drawer For Selected Item Success')
);

export const openCommentSectionDrawerForItinerary = createAction(
  scoped('Open Comment Section Drawer For Itinerary report'),
  props<{ actionType: string }>()
);

export const openFilterActivityDrawer = createAction(
  scoped('Open Filter Activity Drawer'),
  props<{ selectedItem: TemplateExportListItemWithComments }>()
);

export const onCommentsSave = createAction(
  scoped('On Comments Save'),
  props<{ commentPayload: TemplateExportCommentsSavePayload }>()
);

export const onCommentsSaveSuccess = createAction(
  scoped('On Comments Save Success'),
  props<{
    list: TemplateExportListItemWithComments[];
  }>()
);

export const onLoadCompanyContacts = createAction(scoped('On Load Company Contacts'));

export const onLoadCompanyContactSuccess = createAction(
  scoped('On Load Company Contacts Success'),
  props<{ list: FilterActivityCompanyContactSuggesterItem[] }>()
);

export const onLoadCompanyContactFailure = createAction(scoped('On Load Company Contacts Failure'));

export const clearExportState = createAction(scoped('Clear Export State'));

export const exportReport = createAction(scoped('Export Report'));

export const filterActivitiesApply = createAction(
  scoped('Filter Activities Apply'),
  props<{ payload: TemplateExportFilterActivityPayload; selectedItem: TemplateExportListItemWithComments }>()
);

export const filterActivityApplySuccess = createAction(
  scoped('Filter Activity Apply Success'),
  props<{ list: TemplateExportListItemWithComments[] }>()
);

export const prepareTemplateForExport = createAction(scoped('Prepare Template For Export'));

export const setTemplateExportData = createAction(
  scoped('Set Template Export Data'),
  props<{ exportData: ExportDataMap[] }>()
);

export const setSelectedBnyDate = createAction('Set Selected Date', props<{ selectedDate: Date }>());

export const setSelectedBnySecurityId = createAction(
  'Set Selected Security Id',
  props<{ selectedSecurityId: number }>()
);

export const setItineraryComments = createAction(
  scoped('Set Itinerary Comments'),
  props<{ itineraryComments: CommentRequest[] }>()
);
export const setExportList = createAction(
  scoped('Set Export List'),
  props<{ list: TemplateExportListItemWithComments[] }>()
);
function scoped(action: string): string {
  return `[Template Designer Export] ${action}`;
}
